import { sfOr } from 'spring-filter-query-builder';
import { escapeSfqbString } from '../sfqb';
import { sfLike } from './sfqb';

export const makeIs37Filter = (searchParam: string): string =>
    sfOr([sfLike('id', `${escapeSfqbString(searchParam, true)}*`, true)]).toString();

export const makeIs37SensorFilter = (searchParam: string): string => {
    return sfLike('searchLabel', `${escapeSfqbString(searchParam, true)}*`, true).toString();
};
